var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ql-snow wi100",staticStyle:{"color":"#000000"}},[_c('div',{staticClass:"ql-editor",staticStyle:{"padding":"0 !important"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }